import React from 'react';
import {PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import {CATEGORICAL_SEQUENCE} from './chartTheme';

type Slice = {name: string; value: number};

type Props = {
    data: Slice[];
    height?: number;
};

/** A single-series categorical breakdown (status mix, request types, etc.)
 * - always paired with a legend per the dataviz method, since color alone
 * must never carry identity for 2+ series. */
const DonutBreakdown: React.FC<Props> = ({data, height = 240}) => {
    if (!data || data.length === 0 || data.every((d) => d.value === 0)) {
        return <div className="text-muted small py-5 text-center">No data yet.</div>;
    }

    return (
        <ResponsiveContainer width="100%" height={height}>
            <PieChart>
                <Pie data={data} dataKey="value" nameKey="name" innerRadius="55%" outerRadius="80%" paddingAngle={2}>
                    {data.map((_, i) => (
                        <Cell key={i} fill={CATEGORICAL_SEQUENCE[i % CATEGORICAL_SEQUENCE.length]}/>
                    ))}
                </Pie>
                <Tooltip contentStyle={{borderRadius: 10, border: '1px solid #f3f3f9', fontSize: 12}}/>
                <Legend verticalAlign="bottom" height={36} iconType="circle" wrapperStyle={{fontSize: 12}}/>
            </PieChart>
        </ResponsiveContainer>
    );
};

export default DonutBreakdown;
